webpackJsonp([35783957827783],{

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainModule = __webpack_require__(172);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var srcArray = ['./static/photos/moon2.jpg', './static/photos/ocean.jpg', './static/photos/jupiter.jpg', './static/photos/dawn.jpg', './static/photos/antarctica.jpg'];
	
	var srcLength = srcArray.length;
	
	var carouselInterval = null;
	
	var Carousel = function (_Component) {
	    _inherits(Carousel, _Component);
	
	    function Carousel() {
	        _classCallCheck(this, Carousel);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	        _this.state = {
	            src: './static/photos/moon2.jpg',
	            idx: 0
	        };
	        _this.updateImg = _this.updateImg.bind(_this);
	        return _this;
	    }
	
	    Carousel.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        carouselInterval = setInterval(function () {
	            _this2.updateImg();
	        }, 7000);
	    };
	
	    Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	        clearInterval(carouselInterval);
	    };
	
	    Carousel.prototype.updateImg = function updateImg() {
	        this.setState({ src: srcArray[this.state.idx], idx: this.state.idx === srcLength - 1 ? 0 : this.state.idx + 1 });
	    };
	
	    Carousel.prototype.render = function render() {
	        return Glamor.createElement("img", { src: this.state.src, className: _mainModule2.default.carouselImg });
	    };
	
	    return Carousel;
	}(_react.Component);
	
	exports.default = Carousel;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mainModule = __webpack_require__(172);
	
	var _mainModule2 = _interopRequireDefault(_mainModule);
	
	var _Carousel = __webpack_require__(246);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Footer = __webpack_require__(46);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_Component) {
	  _inherits(Main, _Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Main.prototype.render = function render() {
	    return Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement(_Header2.default, { color: "white", position: "fixed" }),
	      Glamor.createElement(
	        "div",
	        { className: _mainModule2.default.main },
	        Glamor.createElement(_Carousel2.default, null),
	        Glamor.createElement(
	          "div",
	          { className: _mainModule2.default.text },
	          Glamor.createElement(
	            "h3",
	            { className: _mainModule2.default.name },
	            "Yvette Zhang"
	          ),
	          Glamor.createElement(
	            "p",
	            { className: _mainModule2.default.sub },
	            "Full Stack Engineer | New York, NY"
	          ),
	          Glamor.createElement(
	            "p",
	            { className: _mainModule2.default.spec },
	            "Specialized in Javascript, React and React Native"
	          ),
	          Glamor.createElement(
	            "div",
	            { className: _mainModule2.default.flex },
	            Glamor.createElement(
	              "p",
	              { className: _mainModule2.default.spec },
	              "Contact:"
	            ),
	            Glamor.createElement(
	              "p",
	              { className: _mainModule2.default.spec },
	              Glamor.createElement(
	                "a",
	                { href: 'mailto:yvettez2016@gmail.com', className: _mainModule2.default.contact },
	                "yvettez2016@gmail.com"
	              )
	            )
	          )
	        )
	      ),
	      Glamor.createElement(_Footer2.default, { color: "white", position: "fixed" })
	    );
	  };
	
	  return Main;
	}(_react.Component);
	
	exports.default = Main;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components----main-module---main---3yBrp","carouselFlex":"src-components----main-module---carouselFlex---3PZKc","text":"src-components----main-module---text---39W0z","textScaleY":"src-components----main-module---textScaleY---18p0I","name":"src-components----main-module---name---1-5eY","spec":"src-components----main-module---spec---2nD2y","sub":"src-components----main-module---sub---2F9Qd","contact":"src-components----main-module---contact---3bL4s","flex":"src-components----main-module---flex---kJqtY","carouselImg":"src-components----main-module---carouselImg---D9QoJ"};

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Main = __webpack_require__(247);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    "div",
	    null,
	    Glamor.createElement(_Main2.default, null)
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ed01586279f442ab603d.js